<template>
  <div>
    <v-card color="grey lighten-5" flat>
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar class="baslik" size="120px" dark color="info">
              <v-toolbar-title>{{$t('current_index_addbuton_label')}} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn @click="ekle()" class="white--text" flat><span class="hidden-sm-and-down">{{$t('save_button')}}</span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list>
                  <a target="_self" v-bind:href="'#/cari/index/'">

                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>



          <v-tabs style="width:100%; height:100%;" dark="" v-model="active" color="blue darken-3" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              Genel
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:500px;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-text-field label="Cari Kod" v-model="Current.Code" :error-messages="errors.collect('carikod')"
                            v-validate="'required'" hide-details="" data-vv-name="carikod" required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Ünvan" v-model="Current.Title" :error-messages="errors.collect('unvan')"
                            v-validate="'required'" data-vv-name="unvan" required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Yetkili" value="" v-model="Current.Authorized">
                          </v-text-field>
                          <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text"
                            item-value="value" clearable label=" Müşteri Tipi">
                          </v-select>
                          <v-text-field hide-details="" label="Telefon Numarası" v-model="Current.Phone1"></v-text-field>
                          <v-text-field hide-details="" label="Telefon Numarası2" v-model="Current.Phone2"></v-text-field>
                          <v-text-field hide-details="" autocomplete='postal-code' label="Cep Telefonu" v-model="Current.Mobile"></v-text-field>
                          <v-text-field hide-details="" label="E-Posta Adresi" v-model="Current.Email"></v-text-field>
                          <v-text-field hide-details="" label="Web Adresi" v-model="Current.Web"></v-text-field>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-textarea v-model="Current.InfoNote" label="Bilgi Notu"></v-textarea>
                          <v-textarea v-model="Current.WarningNote" label="Uyarı Notu"></v-textarea>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>



            </v-tab-item>
            <v-tab href='#1' ripple>
              Fatura Bİlgİ
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium ">Fatura Adres Bilgileri</span>
                            </v-card-title>
                          </v-card>
                          <v-text-field hide-details="" label="Vergi Dairesi" v-model="Current.Invoice.TaxOffice"></v-text-field>
                          <v-text-field hide-details="" label="Vergi Numarası" v-model="Current.Invoice.TaxNumber"></v-text-field>
                          <v-text-field hide-details="" label="Posta Kodu" v-model="Current.Invoice.PostCode"></v-text-field>
                          <v-text-field hide-details="" label="Ülke" v-model="Current.Invoice.Country"></v-text-field>
                          <v-text-field hide-details="" label="İl/İlçe" v-model="Current.Invoice.Province"></v-text-field>
                          <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" label="Adres"></v-textarea>
                          <v-checkbox label="Biletler Faturalanmasın" v-model="biletlerfaturalanmasin" hide-details></v-checkbox>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>


                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> T.C. Kimlik ile işlem gören
                                için</span>
                            </v-card-title>
                          </v-card>

                          <v-text-field hide-details="" label="T.C. Kimlik Numarası" value="" mask="###########"
                            v-model="Current.Invoice.IdentityNumber"></v-text-field>
                          <v-text-field hide-details="" label="Adı" v-model="Current.Invoice.PerFirstName" required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Soyadı" v-model="Current.Invoice.PerFamilyName" required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Ünvan" v-model="Current.Invoice.PerTitle" required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Diğer Adı" v-model="Current.Invoice.PerMiddleName"
                            required>
                          </v-text-field>
                          <v-text-field hide-details="" label="Ön Adı Eki" v-model="Current.Invoice.PerNameSuffix"
                            required>
                          </v-text-field>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>


                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> &nbsp;E-Fatura Mükellef
                                Bilgileri</span>
                            </v-card-title>
                          </v-card>


                          <v-select hide-details="" :items="efaturatipi" v-model="Current.EInvoiceType" item-text="text"
                            item-value="value" label=" E-Fatura Tipi"></v-select>
                          <v-text-field hide-details="" label="Posta Kutusu Etiketi" v-model="Current.PostCodeLabel"></v-text-field>
                          <v-checkbox label="E-Fatura Mükellefi" v-model="efaturamukellefi" hide-details></v-checkbox>
                          <v-checkbox label="Çoklu Posta Kullanıyor" v-model="Current.MultiPostUse" hide-details></v-checkbox>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> &nbsp;E-Arşiv Bilgileri</span>
                            </v-card-title>
                          </v-card>

                          <v-select hide-details="" :items="islembilgileri" v-model="Current.EArchiveSendType"
                            item-text="text" item-value="value" label=" E-Arşiv İşlem Bilgileri Tipi"></v-select>
                          <v-checkbox label="E-Arşiv Yerine Kağıda Bas" v-model="Current.EArchiveSendPaper"
                            hide-details></v-checkbox>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#2' ripple>
              Kontrat
            </v-tab>
            <v-tab-item :id="'2'">
              <v-layout row="" wrap="">

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Tanımlamalar</span>
                            </v-card-title>
                          </v-card>


                          <v-text-field hide-details="" label="Kontrat No" v-model="Current.Contract.ContractNumber"
                            required>
                          </v-text-field>

 <tarihim :etiket="'Sözleşme Başlangıç'" v-bind:value="date" :detaygizle="true" v-model="date" v-bind:defaultvalue="'no'" ></tarihim>


                          <parainput v-model="Current.CreditLimit" :etiket="'Kredi Limiti'" :autocomplete="'autocomplete'"></parainput>
                          <v-text-field hide-details="" label="Döviz" v-model="Current.CreditLimitCurrencyAmount"></v-text-field>
                          <v-select hide-details="" :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod"
                            v-model="Current.CreditLimitCurrency" label="Para Birimi"></v-select>
                          <v-text-field hide-details="" label="Ödeme Şekli" v-model="Current.Contract.PaymentType"></v-text-field>
                          <v-text-field hide-details="" label="Banka Hesap No" v-model="Current.Contract.BankAccountNumber"></v-text-field>
                          <v-text-field hide-details="" label="Banka Şube Kodu" v-model="Current.Contract.BankBranchOffice"></v-text-field>
                          <v-text-field hide-details="" label="DOT9 Şifre" v-model="Current.WebPassword"></v-text-field>
                          <v-text-field hide-details="" autocomplete='postal-code' label="PIN Code" v-model="Current.PinCode"></v-text-field>
                          <v-text-field hide-details="" label="Mil Kodu" v-model="Current.MileCode"></v-text-field>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>


                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Vadeler</span>
                            </v-card-title>
                          </v-card>

                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" type="Number" label="İç Hat" v-model="Current.ExpiryDayDomestic"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-select :items="ichattipi" hide-details="" clearable v-model="Current.ExpiryTypeDomestic"
                                label="Tipi"></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" type="Number" label="Dış Hat" v-model="Current.ExpiryDayInt"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-select :items="ichattipi" hide-details="" label="Tipi" v-model="Current.ExpiryTypeInt"
                                clearable></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" label="Genel" type="Number" v-model="Current.ExpiryDayGeneral"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-select :items="ichattipi" hide-details="" label="Tipi" v-model="Current.ExpiryTypeGeneral"
                                clearable></v-select>
                            </v-flex>
                          </v-layout>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> İndirimler</span>
                            </v-card-title>
                          </v-card>



                          <v-text-field hide-details="" label="İç Hat" v-model="Current.DiscountDom"></v-text-field>
                          <v-text-field hide-details="" label="Dış Hat" v-model="Current.DiscountInt"></v-text-field>
                          <v-text-field hide-details="" label="İç Servis" v-model="Current.DiscountDomService"></v-text-field>
                          <v-text-field hide-details="" label="Dış Servis" v-model="Current.DiscountIntService"></v-text-field>
                          <v-text-field hide-details="" label="Genel" v-model="Current.DiscountGeneral"></v-text-field>

                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>


                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Fatura Maddeleri</span>
                            </v-card-title>
                          </v-card>

                          <v-text-field hide-details="" type="Number" label="Fatura Satır Adet" value="" v-model="Current.Contract.InvoiceRowNumber"></v-text-field>
                          <v-select :items="evethayir" hide-details="" clearable item-text="text" item-value="value"
                            v-model="Current.Contract.InvoicePassengerName" label="Fatura Yolcu Adı"></v-select>
                          <v-select hide-details="" :items="evethayir" clearable item-text="text" item-value="value"
                            v-model="Current.Contract.InvoiceFlightNumber" label="Fatura Uçuş No"></v-select>
                          <v-checkbox label="KDV Muaf" v-model="Kdvmuaf" hide-details></v-checkbox>
                          <v-checkbox label="Kağıt Çıktı İstemiyor" v-model="ciktiistemiyor" hide-details></v-checkbox>
                          <v-checkbox label="Müş. Per. Bilgileri Faturada Çıksın" v-model="musteribilgitipi"
                            hide-details></v-checkbox>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>



              </v-layout>
            </v-tab-item>
            <v-tab href='#3' ripple>
              Servİs Ücret
            </v-tab>
            <v-tab-item :id="'3'">

              <v-layout row="" wrap>
                <v-flex pa-1 xs12 sm12 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap justify-start="" fill-height="">

                          <v-flex xs12 sm12 md12>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium ">İç Hat Servis Ücretleri</span>
                              </v-card-title>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm8 md8>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="red" label>
                                        <span class="white--text">11-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <parainput v-model="ServisParametre.Fiyat11" :id="'Fiyat11'" :etiket="' İç Low Cost Fiyat'"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete id="doviz11" v-model="ServisParametre.Doviztip11" hide-details=""
                                      disabled="" :items="doviztipi" clearable item-text="DovizUnvan" item-value="DovizKod"
                                      label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="red" label>
                                        <span class="white--text"> 12- </span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <parainput :etiket="'İç Eco Cost Fiyat'" v-model="ServisParametre.Fiyat12"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" v-model="ServisParametre.Doviztip12" disabled=""
                                      :items="doviztipi" clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="red" label>
                                        <span class="white--text"> 13-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <parainput :etiket="' İç Business Cost Fiyat'" v-model="ServisParametre.Fiyat13"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip13"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="red" label>
                                        <span class="white--text"> 15- </span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <parainput :etiket="'İç İade Fiyat'" v-model="ServisParametre.Fiyat15"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip15"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="red" label>
                                        <span class="white--text caption"> 19-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <parainput :etiket="'İç Rez. Değişimi Fiyat'" v-model="ServisParametre.Fiyat19"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip19"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox v-model="icYuzdedenHesapla.Yuzdeden" label="İç Hat % Hesapla" hide-details></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-select hide-details="" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapTipi" :items="hesaptipi"
                                   item-text="text" item-value="value" label="Hesap Tipi"></v-select>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <yuzdeinput :etiket="'Yüzde%'" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapYuzde"
                                  :autocomplete="'autocomplete'"></yuzdeinput>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm12 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap justify-start="" fill-height="">
                          <v-flex xs12 sm12 md12>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium ">Dış Hat Servis Ücretleri</span>
                              </v-card-title>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm6 md8>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text"> 21-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="' Dış Short Cost Fiyat'" v-model="ServisParametre.Fiyat21"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip21"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text"> 22- </span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="'Dış Short Business Fiyat'" v-model="ServisParametre.Fiyat22"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm2 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip22"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text"> 31-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="'Dış Long Eco Fiyat'" v-model="ServisParametre.Fiyat31"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip31"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text"> 32-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="'Dış Long Business Fiyat'" v-model="ServisParametre.Fiyat32"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip32"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>

                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text caption"> 33-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="'First Class Fiyat'" v-model="ServisParametre.Fiyat33"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip33"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text caption"> 40-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="'Dış İade Fiyat'" v-model="ServisParametre.Fiyat40"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip40"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi">
                                    </v-autocomplete>
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height="">
                                      <v-chip color="info" label>
                                        <span class="white--text caption"> 44-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <parainput :etiket="' Dış Rez. Değişimi Fiyat'" v-model="ServisParametre.Fiyat44"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip44"
                                      clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout align-content-start="" fill-height="" row wrap>
                              <v-flex xs12 sm6 md12>
                                <v-checkbox v-model="DisYuzdedenHesapla.Yuzdeden" label="Dış Hat % Hesapla"
                                  hide-details></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm6 md12>
                                <v-select hide-details="" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapTipi" :items="hesaptipi"
                                   item-text="text" item-value="value" label="Hesap Tipi"></v-select>
                              </v-flex>
                              <v-flex xs12 sm6 md12>
                                <yuzdeinput :etiket="'Yüzde%'" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <!-- <v-layout align-content-start="" justify-end="" fill-height="" row wrap>
                <v-flex pa-1 xs12 sm2 md2>
                  <v-btn @click="servissil()" block color="info">
                    Servis Bilgilerini Sil
                  </v-btn>
                </v-flex>
                <v-flex pa-1 xs12 sm2 md2>
                  <v-btn @click="serviskaydet()" block="" color="info">
                    Servis Bilgilerini Güncelle
                  </v-btn>
                </v-flex>
              </v-layout>-->
              </v-layout>
            </v-tab-item>

            <v-tab href='#4' ripple>
              DİĞer
            </v-tab>
            <v-tab-item :id="'4'">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md6>
                  <v-card>
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-text-field hide-details="" label="Dış Akt. Cari Kodu" v-model="Current.ExternalCurrentCode">
                          </v-text-field>
                          <v-text-field hide-details="" label="Dış Akt. Muh. Kodu" v-model="Current.ExternalAccountingCode">
                          </v-text-field>
                          <v-text-field hide-details="" label="Aktarım Cari Kodu" v-model="Current.StreamCurrentCode"></v-text-field>
                          <v-text-field hide-details="" label="Arkman Aktarım Kodu" v-model="Current.ArkmanStreamCode"></v-text-field>
                          <v-text-field hide-details="" name="input-3-3" v-model="Current.Invoice.DeliveryAddress"
                            label="Teslimat Adresi"></v-text-field>
                          <v-text-field hide-details="" label="Teslimat Adı" v-model="Current.Invoice.DeliveryName"></v-text-field>
                          <v-autocomplete :items="masrafmerkezi" hide-details="" clearable item-text="CodeName"
                            item-value="Code" v-model="Current.ExpenseCenter" class="text-xs" label="Masraf Merkezi"></v-autocomplete>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm12 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-select hide-details="" clearable v-model="Current.TemplateID" label="Şablon Seçim Profili"></v-select>
                          <v-autocomplete hide-details="" clearable append-icon="search" label="Ana Hesap" v-model="Current.MainAccount"
                            :loading="loading" :items="statecari" item-text="text" item-value="id" :search-input.sync="search1"
                            cache-items=""></v-autocomplete>
                          <v-select hide-details="" clearable label="Hesap Grup" v-model="Current.AccountGroup"></v-select>
                          <v-select hide-details="" clearable label="CM Kodu" :items="cmkodu" v-model="Current.CMCode"></v-select>
                          <v-checkbox label="Profil Zorunlu" v-model="profilzorunlu" hide-details></v-checkbox>
                          <v-checkbox label="Event ID Zorunlu" v-model="eventidzorunlu" hide-details></v-checkbox>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#5' ripple>
              Notlar
            </v-tab>
            <v-tab-item :id="'5'">
              <v-flex pa-1 xs12 sm12 md12>
                <v-card class="white--text">
                  <v-card color="grey lighten-4" flat="">
                    <v-card-actions>

                      <v-layout row="" wrap="">
                        <v-flex xs12 sm12 md12>

                          <v-layout justify-space-between column>
                            <v-textarea hide-details="" label="Notlar"></v-textarea>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-tab-item>
          </v-tabs>







        </v-layout>
      </v-form>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </v-card>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
    import tarihim from "@/components/app/customcomp/tarihim.vue"


  export default {
    data() {
      return {
        tabcontrol3: 0,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],
        search: '',
        search1: '',
        loading: false,
        Current: {
          CompanyCode: '',
          Code: null,
          Title: null,
          Phone1: '',
          Phone2: '',
          Mobile: '',
          Web: '',
          Email: '',
          AccountGroup: '',
          Type: '',
          CMCode: '',
          Reserved1: '',
          Reserved2: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          CustomerType: '',
          TicketBill: '',
          EInvoiceType: '0',
          PostCodeLabel: '',
          EInvoiceCustomer: '',
          MultiPostUse: false,
          EArchiveSendType: 'false',
          EArchiveSendPaper: false,
          CreditLimit: 0,
          CreditLimitCurrencyAmount: 0,
          CreditLimitCurrency: '',
          WebPassword: '',
          PinCode: '',
          MileCode: '',
          ExpiryDayDomestic: '',
          ExpiryTypeDomestic: '',
          ExpiryDayInt: '',
          ExpiryTypeInt: '',
          ExpiryDayGeneral: '',
          ExpiryTypeGeneral: '',
          DiscountGeneral: '',
          DiscountDom: '',
          DiscountInt: '',
          DiscountDomService: '',
          DiscountIntService: '',
          TaxFree: '',
          ExternalCurrentCode: '',
          ExternalAccountingCode: '',
          StreamCurrentCode: '',
          ArkmanStreamCode: '',
          ExpenseCenter: null,
          TemplateID: '',
          ProfileForced: '',
          EventIDForced: '',
          MainAccount: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: '',
            PerFirstName: '',
            PerFamilyName: '',
            PerTitle: '',
            PerMiddleName: '',
            PerNameSuffix: '',
            NoPrint: '',
            CustomerPersonelNoInvoice: '',
            DeliveryAddress: '',
            DeliveryName: ''
          },
          Contract: {
            ContractNumber: '',
            ContractDate: '',
            PaymentType: '',
            BankAccountNumber: '',
            BankBranchOffice: '',
            InvoiceRowNumber: '',
            InvoicePassengerName: '',
            InvoiceFlightNumber: ''
          }
        },
        ServisParametreYedek: {
          ServisKod11: 11,
          Doviztip11: null,
          Fiyat11: 0,

          ServisKod12: 12,
          Doviztip12: null,
          Fiyat12: 0,

          ServisKod13: 13,
          Doviztip13: null,
          Fiyat13: 0,

          ServisKod15: 15,
          Doviztip15: null,
          Fiyat15: 0,

          ServisKod19: 19,
          Doviztip19: null,
          Fiyat19: 0,

          ServisKod21: 21,
          Doviztip21: null,
          Fiyat21: 0,

          ServisKod22: 22,
          Doviztip22: null,
          Fiyat22: 0,

          ServisKod31: 31,
          Doviztip31: null,
          Fiyat31: 0,

          ServisKod32: 32,
          Doviztip32: null,
          Fiyat32: 0,

          ServisKod33: 33,
          Doviztip33: null,
          Fiyat33: 0,

          ServisKod40: 40,
          Doviztip40: null,
          Fiyat40: 0,

          ServisKod44: 44,
          Doviztip44: null,
          Fiyat44: 0,

        },
        ServisParametre: {
          ServisKod11: 11,
          Doviztip11: null,
          Fiyat11: 0,

          ServisKod12: 12,
          Doviztip12: null,
          Fiyat12: 0,

          ServisKod13: 13,
          Doviztip13: null,
          Fiyat13: 0,

          ServisKod15: 15,
          Doviztip15: null,
          Fiyat15: 0,

          ServisKod19: 19,
          Doviztip19: null,
          Fiyat19: 0,

          ServisKod21: 21,
          Doviztip21: null,
          Fiyat21: 10,

          ServisKod22: 22,
          Doviztip22: null,
          Fiyat22: 0,

          ServisKod31: 31,
          Doviztip31: null,
          Fiyat31: 0,

          ServisKod32: 32,
          Doviztip32: null,
          Fiyat32: 0,

          ServisKod33: 33,
          Doviztip33: null,
          Fiyat33: 0,

          ServisKod40: 40,
          Doviztip40: null,
          Fiyat40: 0,

          ServisKod44: 44,
          Doviztip44: null,
          Fiyat44: 0,

        },

        hesaptipi: [{
            text: 'Bilet Tutarı',
            value: 0
          },
          {
            text: 'Bilet Tutarı+Vergiler',
            value: 1
          }
        ],

        icYuzdedenHesapla: {
          Yuzdeden: false,
          HesapTipi: null,
          HesapYuzde: 0
        },
        DisYuzdedenHesapla: {
          Yuzdeden: false,
          HesapTipi: null,
          HesapYuzde: 0
        },


        musteritipi: [{
            text: 'Bireysel',
            value: 'B'
          },
          {
            text: 'Kurumsal',
            value: 'K'
          }
        ],
        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],
        islembilgileri: [{
            text: 'Kağıt Fatura',
            value: 'false'
          },
          {
            text: 'Elektronik Fatura',
            value: 'true'
          }
        ],
        cmkodu: [
          'C', 'M'
        ],
        doviztipi: [],
        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],
        evethayir: [{
            text: 'Evet',
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],
        masrafmerkezi: [],

        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: 'Tutar',
        defaultvalue: 0,
        nameRules: [
          (v) => v && v.length <= 25 || 'max 25 karakter'
        ],

        emailRules: [
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail formatı uygun değil'
        ],


        dictionary: {
          custom: {
            carikod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            unvan: {
              required: () => 'Bu alan boş bırakılamaz',
            },

          }
        },

        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: false,

        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',
        ichatdoviztipi1: false,
        ichatdoviztipi2: false,
        ichatdoviztipi3: false,
        ichatdoviztipi4: false,
        ichatdoviztipi5: false,
        dishatdoviztipi1: false,
        dishatdoviztipi2: false,
        dishatdoviztipi3: false,
        dishatdoviztipi4: false,
        dishatdoviztipi5: false,
        dishatdoviztipi6: false,
        dishatdoviztipi7: false,
        biletlerfaturalanmasin: null,
        efaturamukellefi: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',

      icyuzde:false,
      disyuzde:false
      }
    },

    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {

      ekle: ekle,
      getDateNow: getDateNow,
      onChangecheck: onChangecheck,
      onChangecheckdis: onChangecheckdis,
      karsidegeral: karsidegeral,
      carigetir: carigetir
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      yuzdeinput,
      tarihim
    },
    watch: {
      search1(val) {
        val && this.carigetir(val)
      },
      'icYuzdedenHesapla.Yuzdeden': function (value) {
        if (value == true) {
          this.icyuzde = true
          this.icYuzdedenHesapla.HesapTipi=0
        } else {
          this.icyuzde = false
          this.icYuzdedenHesapla.HesapTipi=null
        }
      },
      'DisYuzdedenHesapla.Yuzdeden': function (value) {
        if (value == true) {
          this.disyuzde = true
          this.DisYuzdedenHesapla.HesapTipi=0
        } else {
          this.disyuzde = false
          this.DisYuzdedenHesapla.HesapTipi=null
        }
      }
    }
  }

  function karsidegeral(val) {
    if (val == true) {
      return false
    } else if (val == false) {
      return false
    }
  }

  function onChangecheck(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.ichatdoviztipi1 == true && nerden != 'ichatdoviztipi1') {
      this.ichatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi2 === true && nerden != 'ichatdoviztipi2') {
      this.ichatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi3 === true && nerden != 'ichatdoviztipi3') {
      this.ichatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi4 === true && nerden != 'ichatdoviztipi4') {
      this.ichatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi5 === true && nerden != 'ichatdoviztipi5') {
      this.ichatdoviztipi5 = karsidegeral(elem1)
    }
  }

  function onChangecheckdis(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.dishatdoviztipi1 == true && nerden != 'dishatdoviztipi1') {
      this.dishatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi2 === true && nerden != 'dishatdoviztipi2') {
      this.dishatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi3 === true && nerden != 'dishatdoviztipi3') {
      this.dishatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi4 === true && nerden != 'dishatdoviztipi4') {
      this.dishatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi5 === true && nerden != 'dishatdoviztipi5') {
      this.dishatdoviztipi5 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi6 === true && nerden != 'dishatdoviztipi6') {
      this.dishatdoviztipi6 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi7 === true && nerden != 'dishatdoviztipi7') {
      this.dishatdoviztipi7 = karsidegeral(elem1)
    }
  }

  function carigetir(v) {
    this.statecari = []
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function ekle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        if (this.biletlerfaturalanmasin == true) {
          this.Current.TicketBill = '1'
        } else {
          this.Current.TicketBill = '0'
        }

        if (this.efaturamukellefi == true) {
          this.Current.EInvoiceCustomer = '1'
        } else {
          this.Current.EInvoiceCustomer = '0'
        }


        if (this.ciktiistemiyor == true) {
          this.Current.Invoice.NoPrint = '1'
        } else {
          this.Current.Invoice.NoPrint = '0'
        }

        if (this.date != null || this.date != '') {
          this.Current.Contract.ContractDate = new Date(this.date)
        }

        if (this.Kdvmuaf == true) {
          this.Current.TaxFree = '1'
        } else {
          this.Current.TaxFree = '0'
        }

        if (this.profilzorunlu == true) {
          this.Current.ProfileForced = '1'
        } else {
          this.Current.ProfileForced = '0'
        }
        if (this.eventidzorunlu == true) {
          this.Current.EventIDForced = '1'
        } else {
          this.Current.EventIDForced = '0'
        }

        if (this.musteribilgitipi === true) {
          this.Current.Invoice.CustomerPersonelNoInvoice = '1'
        } else {
          this.Current.Invoice.CustomerPersonelNoInvoice = '0'
        }
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Current.CompanyCode = credentials.SirketKodu

        var current = this.Current

        this.$http.post(auth.API_URL + 'api/Current/New', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.Current.Code = null;
            this.Current.Title = null;
            this.Kdvmuaf = false;
            this.ciktiistemiyor = false;
            this.musteribilgitipi = false;
            this.profilzorunlu = false;
            this.eventidzorunlu = false;
            this.Current.Phone1 = null;
            this.Current.Phone2 = null;
            this.Current.Mobile = null;
            this.Current.Web = null;
            this.Current.Email = null;
            this.Current.AccountGroup = null;
            this.Current.Type = null;
            this.Current.CMCode = null;
            this.Current.Reserved1 = null;
            this.Current.Reserved2 = null;
            this.Current.Authorized = null;
            this.Current.WarningNote = null;
            this.Current.InfoNote = null;
            this.Current.CustomerType = null;
            this.Current.TicketBill = null;
            this.Current.EInvoiceType = '0';
            this.Current.PostCodeLabel = null;
            this.Current.EInvoiceCustomer = null;
            this.Current.MultiPostUse = false;
            this.Current.EArchiveSendType = false;
            this.Current.EArchiveSendPaper = false;
            this.Current.CreditLimit = null;
            this.Current.CreditLimitCurrencyAmount = null;
            this.Current.CreditLimitCurrency = null;
            this.Current.WebPassword = null;
            this.Current.PinCode = null;
            this.Current.MileCode = null;
            this.Current.ExpiryDayDomestic = null;
            this.Current.ExpiryTypeDomestic = null;
            this.Current.ExpiryDayInt = null;
            this.Current.ExpiryTypeInt = null;
            this.Current.ExpiryDayGeneral = null;
            this.Current.ExpiryTypeGeneral = null;
            this.Current.DiscountGeneral = null;
            this.Current.DiscountDom = 0;
            this.Current.DiscountInt = 0;
            this.efaturamukellefi = false;
            this.Current.DiscountDomService = 0;
            this.Current.DiscountIntService = 0;
            this.Current.TaxFree = 0;
            this.Current.ExternalCurrentCode = null;
            this.Current.ExternalAccountingCode = null;
            this.Current.StreamCurrentCode = null;
            this.Current.ArkmanStreamCode = null;
            this.Current.ExpenseCenter = null;
            this.Current.TemplateID = null;
            this.Current.ProfileForced = null;
            this.Current.EventIDForced = null;
            this.Current.MainAccount = null;
            this.Current.Invoice.Address = null;
            this.Current.Invoice.PostCode = null;
            this.Current.Invoice.Province = null;
            this.Current.Invoice.Country = null;
            this.Current.Invoice.TaxNumber = null;
            this.Current.Invoice.TaxOffice = null;
            this.Current.Invoice.IdentityNumber = null;
            this.Current.Invoice.PerFirstName = null;
            this.Current.Invoice.PerFamilyName = null;
            this.Current.Invoice.PerTitle = null;
            this.Current.Invoice.PerMiddleName = null;
            this.Current.Invoice.PerNameSuffix = null;
            this.Current.Invoice.NoPrint = null;
            this.Current.Invoice.CustomerPersonelNoInvoice = null;
            this.Current.Invoice.DeliveryAddress = null;
            this.Current.Invoice.DeliveryName = null;
            this.Current.Contract.ContractNumber = null;
            this.Current.Contract.ContractDate = null;
            this.Current.Contract.PaymentType = null;
            this.Current.Contract.BankAccountNumber = null;
            this.Current.Contract.BankBranchOffice = null;
            this.Current.Contract.InvoiceRowNumber = null;
            this.Current.Contract.InvoicePassengerName = null;
            this.Current.Contract.InvoiceFlightNumber = null;


          } else if (response.body.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      } else {
        this.active = 0;
      }
    })
  }


</script>

<style>
</style>